import { OverallPerPatientStats, PermissionBit } from "../../../api";
import { DataModel } from "../../../models/data-model";

/**
 * A per-patient stats row, plus the appended "Summary" row whose `patient_id`
 * is `null` (the API types it as `number`, but the summary aggregate has no id).
 */
export type QuestionnaireStatsRow = Omit<
  OverallPerPatientStats,
  "patient_id"
> & {
  patient_id: number | null;
};

export class QuestionnaireStatsModel extends DataModel<QuestionnaireStatsRow> {
  constructor(
    data: QuestionnaireStatsRow[],
    permissions?: PermissionBit[],
    userUUID?: string,
  ) {
    super(data, permissions, userUUID);
  }
}
